export const isRegistrationSuccessfulSelector = (state) => state.registration.isRegistrationSuccessful
